export default "/_next/static/images/40f8cee40897b3b7c967a9845cad7acf.png";